export default Object.freeze({
  Direct: 1,
  Partner: 2,
  Distributor: 3,
  Reseller: 4,
});
